"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigation = exports.navigationRef = void 0;
exports.navigate = navigate;
exports.dispatch = dispatch;
exports.replace = replace;
exports.push = push;
exports.pop = pop;
exports.popToPop = popToPop;
exports.goBack = goBack;
const React = __importStar(require("react"));
const native_1 = require("@react-navigation/native");
exports.navigationRef = React.createRef();
// export const navigation = navigationRef.current
function navigate(name, params) {
    console.log("Navigate it..", name, params);
    exports.navigationRef.current?.navigate(name, params);
    // cast to any to make it work
}
function dispatch(action) {
    exports.navigationRef.current?.dispatch(action);
}
function replace(name, params) {
    console.log("replace it..");
    exports.navigationRef.current?.dispatch(native_1.StackActions.replace(name, params));
}
function push(name, params) {
    console.log("push it..");
    exports.navigationRef.current?.dispatch(native_1.StackActions.push(name, params));
}
function pop(depth) {
    exports.navigationRef.current?.dispatch(native_1.StackActions.pop(depth));
}
function popToPop(name, params) {
    exports.navigationRef.current?.dispatch(native_1.CommonActions.reset({
        index: 1,
        routes: [
            { name: name }, //to go to initial stack screen
        ],
    }));
}
function goBack() {
    exports.navigationRef.current?.goBack();
}
exports.navigation = {
    navigate,
    dispatch,
    replace,
    // push,
    // popToPop,
    goBack,
};
